<div class="media profile-media">
  <img class="b-r-10" (click)="misdatos()" src="assets/images/dashboard/user_profile.png" width="35" alt="">
  <div class="media-body" (click)="misdatos()"><span>{{userName}}</span>
    <p class="mb-0 font-roboto">{{historia}}</p>
  </div>
</div>